import { useMMGRSettings } from '../hoc/withMMGRSettings';
import { MediaManagerSDKAnyItem } from '../media-manager-sdk';
import { decodeWixSiteFolderId, isWixSiteFolder } from '../media-manager-sdk/items';
import { parseSiteMediaToken } from '../siteMediaToken';

export const isSameSiteToken = (siteMediaToken) => (item: MediaManagerSDKAnyItem) => {
  if (!isWixSiteFolder(item)) {
    return false;
  }

  const { metaSiteId: currentMetaSiteId } = parseSiteMediaToken(siteMediaToken);

  const { siteMediaToken: itemSiteMediaToken } = decodeWixSiteFolderId(item.id);
  const { metaSiteId: itemMetaSiteId } = parseSiteMediaToken(itemSiteMediaToken);

  return itemMetaSiteId === currentMetaSiteId;
};

export const useIsCurrentSite = (item: MediaManagerSDKAnyItem) => {
  const {
    mmgrSettings: { siteMediaToken },
  } = useMMGRSettings();

  return { isCurrentSite: isSameSiteToken(siteMediaToken)(item) };
};
